import axios from "axios";

const baseUrl = "https://us-central1-setpoint-62e00.cloudfunctions.net/";

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    Accpet: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origi": "*",
  },
});

export default api;
